import React, { useEffect, useState } from 'react';
import { BarChart3, Loader2, NotebookPen, Users, Wallet, Percent } from 'lucide-react';
import { DashboardLayout } from '../../app/layouts/DashboardLayout';
import { ADMIN_NAV } from '../../constants/nav';
import { fetchJournalReport, fmtMoney } from '../../features/journal/api/journal';
import type { JournalReport } from '../../types';
import { StatCard } from '../../components/common/StatCard';
import { JOURNAL } from '../../constants/testIds';

export default function AdminJournalReportPage() {
  const [report, setReport] = useState<JournalReport | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchJournalReport().then(setReport).finally(() => setLoading(false));
  }, []);

  return (
    <DashboardLayout navItems={ADMIN_NAV} title="Trading Journal Reports">
      <div className="max-w-5xl" data-testid={JOURNAL.adminPage}>
        <div className="mb-6 flex items-center gap-3">
          <div className="w-11 h-11 rounded-xl bg-cyan-400/10 border border-cyan-400/30 flex items-center justify-center">
            <BarChart3 className="w-5 h-5 text-cyan-400" strokeWidth={1.5} />
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-cyan-400">Aggregate Report</p>
            <h2 className="text-2xl sm:text-3xl tracking-tight font-medium text-white">Trading Journal Reports</h2>
          </div>
        </div>

        <p className="text-white/40 text-sm mb-6">Laporan agregat saja — konten jurnal pribadi member tidak ditampilkan.</p>

        {loading ? (
          <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 text-cyan-400 animate-spin" strokeWidth={1.5} /></div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <StatCard icon={NotebookPen} label="Total Entries" testId={JOURNAL.reportEntries} accent>
              <p className="text-3xl font-light text-white">{report?.total_entries ?? 0}</p>
            </StatCard>
            <StatCard icon={Users} label="Active Journal Users" testId={JOURNAL.reportUsers}>
              <p className="text-3xl font-light text-white">{report?.active_journal_users ?? 0}</p>
            </StatCard>
            <StatCard icon={Wallet} label="Aggregate P/L" testId={JOURNAL.reportPl}>
              <p className={`text-3xl font-light ${report && report.aggregate_profit_loss >= 0 ? 'text-emerald-400' : 'text-red-400'}`}>{fmtMoney(report?.aggregate_profit_loss)}</p>
            </StatCard>
            <StatCard icon={Percent} label="Aggregate Win Rate" testId="report-win-rate">
              <p className="text-3xl font-light text-white">{report?.aggregate_win_rate ?? 0}%</p>
              <p className="text-xs text-white/40 mt-1">{report?.aggregate_wins ?? 0}W / {report?.aggregate_losses ?? 0}L</p>
            </StatCard>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
}
